<template>
    <solution-consultant v-if="question && $auth.user().id === question.consultant_id" :question="question"/>
    <solution-expert v-else-if="question" :question="question"/>
</template>
<script>

import SolutionExpert from './SolutionExpert'
import SolutionConsultant from './SolutionConsultant'

export default {
  components: {
    SolutionConsultant,
    SolutionExpert},
  props: ['questionId'],
  name: 'Solution',
  data () {
    return {
      question: null
    }
  },
  methods: {
    getResources: function () {
      this.axios.get('/question/receive/' + this.questionId + '?relations={solutions}')
        .then((response) => {
          this.question = response.data
        }).catch(function (error) {
        })
    }
  },
  beforeMount () {
    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chatSolution/Solution.vue